<template>
  <BlockLoading v-if="isPending" class="py-6" />

  <BlockError
    v-else-if="error"
    can-retry
    class="py-6"
    @retry="refetch"
  >
    <strong>Error loading outstanding actions</strong>
    <p>{{ error?.message }}</p>
  </BlockError>

  <div
    v-else
    :class="['card', classes.card, !items.length && 'd-none' ]"
  >
    <div class="card-header-icon">
      <h2 class="h4 mb-0">{{ title }}</h2>
      <i class="bx bx-task" aria-hidden="true" />
    </div>

    <div v-if="items.length" class="card-body p-0">
      <ul :class="['list-group list-group-secondary list-group-flush overflow-y-auto', classes.listGroup]">
        <a
          v-for="(item, index) in items"
          :key="index"
          :href="`/projects/?presetId=${item.presetId}`"
          :class="['list-group-item list-group-item-action list-group-item-kvp', `list-group-item-${item.variant}`]"
        >
          {{ item.presetName }}
          <span :class="`badge text-bg-${item.variant || 'light'} rounded-pill ms-3`">{{ formatNumber(item.count) }}</span>
        </a>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, toRefs, watch } from 'vue'

import BlockError from '@shared/components/BlockError.vue'
import BlockLoading from '@shared/components/BlockLoading.vue'
import { formatNumber } from '@shared/utils/number'

import { getOutstandingActions } from '@projects/api/dashboard.api'

const props = defineProps({
  noItemsText: {
    type: String,
    default: 'No outstanding actions.',
  },
  title: {
    type: String,
    default: 'Outstanding Actions',
  },
  classes: {
    type: Object,
    default: () => ({}),
  },
})

const { classes, title } = toRefs(props)
const items = ref([])

const {
  data,
  error,
  isPending,
  refetch,
} = getOutstandingActions()

watch(data, (newData) => {
  if (!newData) return
  items.value = newData.data || []
})
</script>
